import clsx from "clsx"
import type { AriaRole } from "react"

import styles from "./Dot.module.css"

export interface DotProps {
  color: "grey" | "green" | "amber" | "purple"
  role?: AriaRole
}

export function Dot(props: DotProps) {
  const { color, role = "status" } = props

  return <div role={role} className={clsx(styles.root, styles[color])} />
}
